"use strict";
/*
 * Created on 09 19 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Competitor_1 = require("../model/Competitor");

var CompetitorConverter_1 = require("./CompetitorConverter");
/**
 * @author Jaroslav Sevcik
 */


var CompetitorConverterImpl =
/*#__PURE__*/
function (_CompetitorConverter_) {
  _inherits(CompetitorConverterImpl, _CompetitorConverter_);

  function CompetitorConverterImpl() {
    _classCallCheck(this, CompetitorConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Competitor_1.Competitor(conversions.documentToClassId(source), source.externalId, source.name);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name
      });
      return result;
    }
  }]);

  return CompetitorConverterImpl;
}(CompetitorConverter_1.CompetitorConverter);

exports.CompetitorConverterImpl = CompetitorConverterImpl;